import React, { useState } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import SwipeableViews from 'react-swipeable-views';
import { useTheme, styled, Typography } from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';
import CourseFinalTest from './CourseFinalTest';
import { useTranslation } from 'react-i18next'

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography component={'span'}>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};
function CourseContent({ attachments = [], links = [], questions = [] }) {
    const { t } = useTranslation();
    const theme = useTheme();
    const AntTabs = styled(Tabs)(({ theme }) => ({
        marginTop: '2rem',
        borderBottom: '1px solid #e8e8e8',
        justifyContent: 'space-between',

        '& .MuiTabs-indicator': {
            backgroundColor: theme.palette.text.default,
        }, '& .MuiTabs-flexContainer': {
            justifyContent: 'space-around',

        },
    }));

    const AntTab = styled((props) => <Tab disableRipple {...props} />)(({ theme }) => ({
        textTransform: 'none',
        minWidth: 0,
        [theme.breakpoints.up('sm')]: {
            minWidth: 0,
        },
        fontWeight: theme.typography.fontWeightRegular,
        fontSize: '1.5em',
        marginRight: theme.spacing(1),
        color: theme.palette.text.secondary,


        '&.Mui-selected': {
            color: theme.palette.text.default,
            fontWeight: theme.typography.fontWeightMedium,
        },

    }));

    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    const handleChangeIndex = (index) => {
        setValue(index);
    };
    return (
        <Box sx={{ width: '100%' }}>
            <AntTabs
                value={value}
                onChange={handleChange}
                textColor="primary"
                indicatorColor="primary"
                aria-label="secondary tabs example"
            >
                <AntTab value={0} label={t("attachments")} />
                <AntTab value={1} label={t("links")} />
                <AntTab value={2} label={t("finaltest")} />
            </AntTabs>
            <SwipeableViews
                axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                index={value}
                onChangeIndex={handleChangeIndex}
            >
                <TabPanel value={value} index={0} dir={theme.direction}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                        {attachments.map((attachment) => <Typography key={attachment.id || attachment.file_path}>{attachment.file_name || attachment.name}</Typography>)}
                    </Box>
                </TabPanel>
                <TabPanel value={value} index={1} dir={theme.direction}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                        {links.map((link, index) => (
                            <Box key={`course-link-${index}`} sx={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
                                <LinkIcon sx={{ color: theme.palette.text.secondary }} />
                                <Typography sx={{ color: index === 0 ? theme.palette.text.default : theme.palette.text.secondary }}>{link}</Typography>
                            </Box>
                        ))}
                    </Box>
                </TabPanel>
                <TabPanel value={value} index={2} dir={theme.direction}>
                    <CourseFinalTest data={questions} />
                </TabPanel>
            </SwipeableViews>
        </Box>
    );
}

export default CourseContent;
